<script setup lang="ts">
const props = defineProps<{
  copyrightText: string;
}>();
</script>

<template>
  <article>
    <div class="copyright-container">
      <div class="copyright-on-hover">
        <p><i class="ri-copyright-line"/><b>Image Credit:</b></p>
        <small>{{ props.copyrightText }}</small>
      </div>

      <span class="copyright-icon"><i class="ri-copyright-line"/></span>
      <small class="copyright-text">
        <b>Image Credit:</b> {{ props.copyrightText.substring(0, 25) }}...
      </small>
    </div>
  </article>
</template>

<style scoped>
.copyright-container {
  position: relative;
  display: flex;
  align-items: center;
  align-content: center;
  justify-items: center;
  justify-content: center;
}

.copyright-on-hover {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  padding: 10px;
  border-radius: 8px;
  display: none;
  white-space: wrap;
  z-index: 1000;
  text-align: left;
  max-width: 300px;
  min-width: 300px;
  p {
    margin: 0;
    padding: 0;
    font-size: 1rem;
  }
  span {
    font-size: 10px;
  }
}

.copyright-on-hover:after {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 8px solid transparent;
  border-top-color: white;
}

.copyright-container:hover .copyright-on-hover {
  display: block;
}
</style>
